<template> 
  <CreateUser /> 
</template> 

<script> 
  import CreateUser from '../components/CreateUser' 
  export default { 
    components: { 
      CreateUser 
    } 
  } 
</script> 